import { motion } from "framer-motion";
import { Leaf, CloudRain, Droplets, Flower2, Fence, PaintRoller, Wrench, ArrowUpRight } from "lucide-react";

const ICONS = {
  "lawn-mowing": Leaf,
  "gutter-cleaning": CloudRain,
  "pressure-washing": Droplets,
  "garden-weeding": Flower2,
  "fence-repair": Fence,
  "painting": PaintRoller,
  "general-handyman": Wrench,
};

export const ServicesCatalog = ({ services, onSelect }) => (
  <section id="services" data-testid="services-section" className="py-20 lg:py-32 px-4 sm:px-8 lg:px-12 max-w-7xl mx-auto">
    <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.7 }}
                className="mb-14">
      <p className="text-xs font-mono-brand uppercase tracking-[0.25em] text-amber-400 mb-4">01 — What We Do</p>
      <h2 className="text-4xl sm:text-5xl lg:text-6xl font-condensed font-extrabold uppercase tracking-tight leading-none">
        Every Job.<br /><span className="text-slate-500">One Visit.</span>
      </h2>
    </motion.div>
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {services.map((s, i) => {
        const Icon = ICONS[s.slug] || Wrench;
        return (
          <motion.button
            key={s.slug}
            onClick={() => onSelect(s.slug)}
            data-testid={`service-select-${s.slug}`}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.55, delay: (i % 3) * 0.1 }}
            className={`group text-left bg-[#0F172A] border border-amber-500/15 p-6 sm:p-8 transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_12px_30px_rgba(245,158,11,0.2)] hover:border-amber-500/60 ${i === 0 ? "lg:col-span-2" : ""}`}
          >
            <div className="flex items-start justify-between mb-6">
              <span className="w-11 h-11 bg-amber-500/10 border border-amber-500/30 flex items-center justify-center">
                <Icon className="w-5 h-5 text-amber-400" />
              </span>
              <ArrowUpRight className="w-5 h-5 text-slate-600 group-hover:text-amber-400 transition-colors duration-300" />
            </div>
            <h3 className="text-lg sm:text-xl font-condensed font-bold uppercase tracking-wide text-slate-100 mb-2">{s.name}</h3>
            <p className="text-sm text-slate-400 leading-relaxed mb-6">{s.blurb}</p>
            <div className="flex items-center justify-between">
              <span className="text-xs font-mono-brand uppercase tracking-[0.15em] text-amber-400 border border-amber-500/30 px-3 py-1.5">{s.estimate}</span>
              <span className="text-xs font-mono-brand uppercase tracking-[0.15em] text-slate-500">{s.duration}</span>
            </div>
          </motion.button>
        );
      })}
    </div>
  </section>
);
